import React from 'react';
import { Box, keyframes } from '@edreamsodigeo/prisma-design-system';

const balanceSpring = keyframes`
    0% {
        transform: rotate(0deg);
    }
    10% {
        transform: rotate(0deg);
    }
    15% {
        transform: rotate(10deg);
    }
    20% {
        transform: rotate(0deg);
    }
    25% {
        transform: rotate(-3deg);
        #blur-text {
            filter: blur(20px);
        }
    }
    30% {
        transform: rotate(3deg);
    }
    35% {
        transform: rotate(-2deg);
    }
    40% {
        transform: rotate(2deg);
    }
    45% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(0deg);
    }
`;

export const BalanceSpring = ({ children, delay, duration = 1300 }) => {
  return (
    <Box
      sx={{
        animationName: `${balanceSpring}`,
        animationDuration: `${duration}ms`,
        animationTimingFunction: 'cubic-bezier(0.001, 0.01, 0.001, 1)',
        display: 'inline-flex',
        animationDelay: `${delay || 0}ms`,
        animationIterationCount: 'infinite',
        transformOrigin: 'center center',
      }}
    >
      {children}
    </Box>
  );
};
